import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import useApi from "$src/core/hooks/use-api";
import useAuth from "$src/core/hooks/use-auth";
import { queryKey as watchlistQueryKey } from "$src/core/queries/use-watchlist-query";

const MUTATION_KEY = ["watchlist-add"];

type Variables = {
  id: string;
};

const useWatchlistAddMutation = () => {
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  const { api } = useApi();

  const mutationFn = useCallback(
    ({ id }: Variables) => {
      if (!profile?.id) {
        throw new Error("Profile ID is required");
      }
      return api.addWatchlistItem(profile.id, id);
    },
    [api, profile],
  );

  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: watchlistQueryKey({ profileId: profile?.id ?? "" }),
      });
    },
  });
};

export default useWatchlistAddMutation;
